import { AccordionDropdown } from '@one-snap/sparkles';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

interface QuestionProps {
  faq: string;
  stepsImg: boolean[];
}
export const Question = (props: QuestionProps) => {
  const { faq, stepsImg } = props;
  const t = useTranslations('help');
  return (
    <div className="border-b-2 mb-2">
      <AccordionDropdown>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color="primary" />}
          id={faq}
        >
          <div className="flex, items-center " style={{ color: '#2B2B91' }}>
            <div className=" headingS md:headingM" data-testid={faq}>
              {t(`commonQuestions.questions.${faq}.question`)}
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className="flex, flex-col">
          {stepsImg.map((isImgDisplayed, index) => (
            <div key={`step${index + 1}`}>
              <div
                className="body md:headingS mb-4 mt-2"
                data-testid={`step${index + 1}`}
              >
                {t(`commonQuestions.questions.${faq}.answer.step${index + 1}`)}
              </div>
              {isImgDisplayed && (
                <Image
                  src={t(
                    `commonQuestions.questions.${faq}.answer.imageStep${
                      index + 1
                    }`
                  )}
                  alt={`image_step_${index + 1}`}
                  width={800}
                  height={100}
                  data-testid={`image_step_${index + 1}`}
                />
              )}
            </div>
          ))}
        </AccordionDetails>
      </AccordionDropdown>
    </div>
  );
};
